import { Visible } from 'design-system';
import type React from 'react';
import type { PropsWithChildren } from 'react';

import { MeetingContent } from './MeetingContent';
import { useMeeting } from './MeetingRoomProvider';

export const MeetingRoomDisplayProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { meetingState } = useMeeting();
  const showMeeting = meetingState.type !== 'out-of-call';

  return (
    <>
      {children}

      <Visible if={showMeeting}>
        <MeetingContent />
      </Visible>
    </>
  );
};
